import { render, staticRenderFns } from "./AccountContacts.vue?vue&type=template&id=223f4519&scoped=true"
import script from "./AccountContacts.vue?vue&type=script&lang=js"
export * from "./AccountContacts.vue?vue&type=script&lang=js"
import style0 from "./AccountContacts.vue?vue&type=style&index=0&id=223f4519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f4519",
  null
  
)

export default component.exports